import React from 'react'
import Title from '../Components/Title';
import { MainLayout, InnerLayout } from '../Styles/mainLayouts';
import GitHubCalendar from 'react-github-calendar';
import styled from 'styled-components'
import Github from '../Components/Github';

const GithubStyled = styled.div`
    @media screen and (max-width: 700px){
    margin: auto;
    }
`

function StatisticsPage() {
    return (
        <MainLayout id="StatisticsPage">
            <Title title={'Statistics'} />
            <InnerLayout data-aos="fade-up">
                <GithubStyled>
                    <Github />
                    <GitHubCalendar username="ahsanofficial" />
                </GithubStyled>
            </InnerLayout>
        </MainLayout>
    )
}
export default StatisticsPage